export function parsePDPPathURL(path) {
  if (path === undefined) {
    return 'home'
  }

  const terms = path.replace(/\/$/, '')
  const page = `/magazines/${terms.split('/').pop()}`

  return page
}

export function parseCLPPathURL(path) {
  if (path === undefined) {
    return 'home'
  }

  return path.replace(/\/$/, '').replace(/\/\//, '/')
}

export function sliceDataForDebug(magazine) {
  const newMagazine = { ...magazine }
  for (const [key, value] of Object.entries(magazine)) {
    if (typeof value === 'string' && value.length >= 40) {
      newMagazine[key] = value.substr(0, 39) + '...'
    }
  }
  return newMagazine
}

export function activeBannersImages({ banners, date, addExtraImage }) {
  // console.log('activeBannersImages banners=', banners)
  // console.log('activeBannersImages date=', date)
  // console.log('activeBannersImages addExtraImage=', addExtraImage)
  // No banners
  if (!banners) {
    return []
  }

  let baseDate = Date.now()
  if (date) {
    baseDate = date
    console.log('SET baseDate=', baseDate)
  }
  // Get onlly the banners that are within the condition activeFrom <= now <= activeTo
  let activeImages = banners.filter(item => {
    const now = new Date(baseDate)
    const activeFrom = new Date(item.activeFrom)
    const activeTo = new Date(item.activeTo)
    // console.log('')
    // console.log('NEW Banner image=', item)
    // console.log('now=', now)
    // console.log('activeFrom=', activeFrom)
    // console.log('activeTo=', activeTo)
    if (now >= activeFrom && now <= activeTo) {
      // Condition activeFrom <= now <= activeTo
      // console.log('->>ACTIVE BANNER')
      return true
    } else {
      // console.log('->>EXPIRED BANNER')
    }
  })

  // console.log('ACTIVE activeImages=', activeImages)

  if (addExtraImage) {
    if (activeImages.length === 2) {
      // Banners array with ONLY 2 elements
      // Add a Free Digital Access or a The Week
      if (activeImages.some(image => image.link === '/magazines-with-free-digital-access')) {
        activeImages.push({
          imageUrl: 'https://magazine.imgix.net/easybanner/JMAG_Spotlight_THEWEEK_1990x550.png?fm=png&auto=format&w=1025',
          link: '/magazines/the-week-magazine',
          alt: 'SPOTLIGHT - The Week - 6 free issues',
          key: 2
        })
      } else {
        activeImages.push({
          imageUrl: 'https://magazine.imgix.net/easybanner/JMAG_Instant_Access_Spotlight_Banne.png?fm=png&auto=format&w=1025',
          link: '/magazines-with-free-digital-access',
          alt: 'SPOTLIGHT - Digital Access',
          key: 3
        })
      }
    }
  }

  if (activeImages.length > 3) {
    // Banners array with MORE THAN 3 elements
    activeImages = [...activeImages.slice(0, 3)]
  }

  // console.log('FINAL activeBannersImages=', activeImages)
  return activeImages
}

export function createFAQsId(item) {
  const id = item?.title?.replace(/\?$/g, '').replace(/[\W*]/g, '-') || item?.question?.replace(/\?$/g, '').replace(/[\W*]/g, '-') || ''
  console.log(`createFAQsId id=${id.toLowerCase()} item=`, item)
  return id.toLowerCase()
}

export function createPathOrURLWithQueryParam({ pathOrURL, query }) {
  if (process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_ENABLED === 'true') {
    // Determine if pathOrURL is a full URL or just a path
    let url

    if (pathOrURL.startsWith('http://') || pathOrURL.startsWith('https://')) {
      // If it's a full URL, create a URL object
      url = new URL(pathOrURL)
    } else {
      // If it's a path, assume it belongs to a base URL (e.g., your domain)
      url = new URL(pathOrURL, process.env.BASE_URL) // Create the URL using the base URL
    }

    // Add the OPTION Query Parameter
    url.searchParams.append(process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_KEY, process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_VALUE)

    // Add all the rest of Query Parameters
    if (process.env.OPTIONS_RETAIN_CURRENT_QUERY_PARAMS === 'true' && query) {
      Object.keys(query).forEach(key => {
        if (key !== process.env.OPTIONS_ADD_QUERY_STRING_TO_URL_KEY) {
          // console.log(`QS ${key} ${query[key]}`)
          url.searchParams.append(key, query[key])
        }
      })
    }

    // Always propagate useCache is present
    if (query?.useCache) {
      url.searchParams.append('useCache', query.useCache)
    }

    // console. log(`createPathOrURLWithQueryParam ${url.toString().replace(process.env.BASE_URL, '')}`)
    // Get the updated URL as a string
    return url.toString().replace(process.env.BASE_URL, '')
  }
  return pathOrURL
}
